module.exports = __webpack_public_path__ + "img/G27-iran.79bc4fe4.png";